var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoVLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 6,
    fill: "white",
    stroke: "#4E5978",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.934 18L7.014 8.2H9.604L11.438 13.044C11.578 13.4267 11.6947 13.7487 11.788 14.01C11.8813 14.2713 11.9653 14.528 12.04 14.78C12.1147 14.5187 12.194 14.262 12.278 14.01C12.3713 13.7487 12.4927 13.4267 12.642 13.044L14.406 8.2H16.94L13.006 18H10.934Z",
    fill: "#4E5978"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoVLetter);
export default __webpack_public_path__ + "static/media/ico-V-letter.b3586316.svg";
export { ForwardRef as ReactComponent };